<template>
  <div class="flex-page">
    <a-form class="ctrl" layout="inline">
      <a-form-item label="标题">
        <a-input
          style="min-width: 200px"
          v-model="search.title"
          placeholder="请输入标题关键词"
        ></a-input>
      </a-form-item>
      <a-form-item label="作者">
        <a-input
          style="min-width: 200px"
          v-model="search.author"
          placeholder="请输入作者姓名"
        ></a-input>
      </a-form-item>
      <a-form-item label="发布时间">
        <a-date-picker
          style="width: 130px"
          v-model="search.start_at"
          placeholder="从"
        />-
        <a-date-picker
          style="width: 130px"
          v-model="search.end_at"
          placeholder="至"
        />
      </a-form-item>

      <a-form-item>
        <a-button type="primary" @click="doSearch">搜索</a-button>
      </a-form-item>
    </a-form>

    <div class="article-page">
      <div class="file-menu" v-if="cateList.length > 0">
        <div
          class="menu-item"
          v-for="(item, index) in cateList"
          :key="index"
          @click="a(item)"
          :class="{ active: item.id == search.cate_id }"
        >
          {{ item.cate_name }}
        </div>
      </div>
      <div class="list">
        <div class="statistics">共{{ amount }}条</div>
        <a-table
          bordered
          :dataSource="list"
          :columns="columns"
          :pagination="false"
          size="small"
          :rowKey="(record) => record.id"
        >
          <template slot="thumb" slot-scope="text, record">
            <img
              v-if="record.thumb_show"
              :src="record.thumb_show"
              style="height: 35px"
              alt=""
            />
          </template>
          <template slot="caozuo" slot-scope="text, record">
            <router-link :to="'/article/view?id=' + record.id">
              <a-button size="small" type="primary"> 查看 </a-button>
            </router-link>

            <router-link :to="'/article/edit?id=' + record.id + '&type=' + search.type">
              <a-button style="margin-left: 5px" size="small" type="primary">
                编辑
              </a-button>
            </router-link>

            <a-popconfirm
              title="确定要删除吗"
              @confirm="del(record.id)"
              okText="确定"
              cancelText="取消"
            >
              <a-button style="margin-left: 5px" type="danger" size="small">
                删除
              </a-button>
            </a-popconfirm>
          </template>
        </a-table>
        <a-pagination
          @change="onChange"
          :total="amount"
          :defaultPageSize="50"
          :defaultCurrent="search.now_page"
          showQuickJumper
          class="margin15"
        />
      </div>
    </div>
  </div>
</template>

<style lang='scss' scoped>

</style>

<script>
export default {
  data() {
    return {
      columns: [
        {
          title: "#",
          dataIndex: "id",
        },
        {
          title: "标题",
          dataIndex: "title",
        },
        {
          title: "作者",
          dataIndex: "author",
        },
        {
          title: "发布时间",
          dataIndex: "created_at",
        },
        {
          title: "操作",
          dataIndex: "caozuo",
          scopedSlots: {
            customRender: "caozuo",
          },
        },
      ],
      search: {
        type: 0,
        title: "",
        author: "",
        start_at: null,
        end_at: null,
        cate_id: 0,
        now_page: 1,
      },
      amount: 0,
      pages: 1,
      cateList: [],
      list: [],
    };
  },
  watch: {
    '$route.query.type' () {
      console.log(this.$route.query.type);

    }
  },
  async created() {
    this.search.type = this.$route.query.type;
    // 获取所有的资料分类
    const r = await this.$axios.get("/article/getCateList?type=" + this.search.type);

    if (r.status == 1) {
      r.list.unshift({
        id: 0,
        cate_name: '所有类别'
      })
      this.cateList = r.list;
    }
  },
  mounted() {
    this.getList();
  },
  methods: {
    doSearch() {
      this.search.now_page = 1;
      this.getList();
    },
    async getList() {
      const r = await this.$axios.post("/article/getArticleList", this.search);
      this.list = r.list;
      this.amount = r.amount;
    },
    onChange(e) {
      this.search.now_page = e;
      this.getList();
    },
    async del(id) {
      const r = await this.$axios.post("/article/updateArticle", {
        id: id,
        status: 0,
      });

      if (r.status == 1) {
        this.getList();
      }
    },
    a(e) {
      this.search.cate_id = e.id;
      this.getList();
    },
  },
};
</script>

<style>
</style>